import Axios from 'axios'



let instance = Axios.create()

instance.interceptors.response.use(function(response) {
  // Do something with response data
  return response.data;
}, function(error) {
  console.log("error", error.response)
  if (!error.response) {
    return Promise.reject({
      error: "Connection error"
    })
  }
  if (!error.response.status) {
    return Promise.reject({
      error: "Connection error"
    })
  }
  /*
  if (error.response.status == 403) {
    alert("Unauthorized")
    //store.commit('account/logout')
  }
  */
  return Promise.reject({
    status: error.response.status,
    error: error.response.data
  });
});
/*
const token = localStorage.getItem('token')
if (token) {
  Axios.defaults.headers.common['Authorization'] = token
}
*/
let api_host;
if (window.location.href.includes("localhost")) {
  api_host = "http://localhost:3000/api"
} else {
  api_host = "/api"
}
instance.defaults.baseURL = api_host

export default instance;
